import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateProfileField } from 'redux/profiles/ProfilesActions';
import { updateFileInformation } from 'redux/files/FilesActions';
import ProfileDataFileParser from "./ProfileDataFileParser";

const mapDispatchToProps = dispatch => ({
  profileActions: bindActionCreators({ updateProfileField }, dispatch),
  fileActions: bindActionCreators({ updateFileInformation }, dispatch)
});

export default connect(null, mapDispatchToProps)(ProfileDataFileParser);



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/profileDataFileParser/ProfileDataFileParserConnector.js